import React, { useCallback, useEffect, useState } from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import BackButton from '../../../common/BackButton';
import PaymentAccountFormLoader from '../../../common/PaymentAccountFormLoader';
import styles from './styles.styl';
import {
  selectPaymentInfoModalFormLoading,
  selectPaymentInfoModalPayaFormURL,
} from '../../../../redux/programs/selectors';
import { paymentInfoModalActions } from '../../../../redux/programs/payment-info-modal';
import { useInjectSaga } from '../../../../redux/injectSaga';
import payaAccountFormSaga from '../../../../redux/healthboard/sagas/paya-account-form-saga';
import { RESTART_ON_REMOUNT } from '../../../../redux/sagaInjectors';

const HEADER_HEIGHT = 56;

function PayaAccountForm({ onClose, options: { noCards = false } }) {
  useInjectSaga({
    key: 'payaAccountFormSaga',
    saga: payaAccountFormSaga,
    mode: RESTART_ON_REMOUNT,
  });

  const formLoading = useSelector(selectPaymentInfoModalFormLoading);
  const payaFormUrl = useSelector(selectPaymentInfoModalPayaFormURL);
  const dispatch = useDispatch();

  const [height, setHeight] = useState();
  const [loading, setLoading] = useState(true);

  const formTitle = 'program.membership.payaAccountForm.title';

  const formDescription = 'profile.payment.addCardForFutureUse';

  const showLoader = formLoading || loading || !payaFormUrl;

  const finishLoading = () => setLoading(false);

  const handleBack = useCallback(() => {
    if (noCards) {
      dispatch(paymentInfoModalActions.close());
    }
    onClose();
  }, [onClose, noCards]);

  useEffect(() => {
    setHeight(window.innerHeight - HEADER_HEIGHT);
  }, []);

  useEffect(() => {
    dispatch(paymentInfoModalActions.clearPayaForm());
  }, []);

  return (
    <div className={styles.root}>
      <BackButton
        onBack={handleBack}
        className={styles.backBtn}
        minWidth={100}
      />

      <div className={styles.header}>
        <p className={styles.headerTitle}>
          <FormattedMessage id={formTitle} />
        </p>
        {!showLoader && (
          <div className={styles.headerDescription}>
            <FormattedMessage id={formDescription} />
          </div>
        )}
      </div>

      <div
        className={cn(styles.paymentView, {
          [styles.paymentViewLoading]: loading,
        })}
      >
        {showLoader && (
          <div className={styles.loader}>
            <PaymentAccountFormLoader />
          </div>
        )}

        {payaFormUrl && (
          <iframe
            title="paya-form-url"
            src={payaFormUrl}
            height={height}
            onLoad={finishLoading}
          />
        )}
      </div>
    </div>
  );
}

PayaAccountForm.propTypes = {
  onClose: PropTypes.func,
  options: PropTypes.shape({
    noCards: PropTypes.bool,
  }),
};

export default PayaAccountForm;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/PayaAccountForm/index.jsx